/**
 * Room model
 */

import { Exit, SetupExitData } from './Exit';
import { Action, SetupActionData } from './Action';
import { CustomProperty, SetupCustomPropertyData } from './CustomProperty';

// Forward declaration
declare function ArrayCloneForDiff(arr: any[]): any[];

export class Room {
    Description: string = "";
    SDesc: string = "";
    Name: string = "";
    Group: string = "None";
    Exits: Exit[] = [];
    Actions: Action[] = [];
    CustomProperties: CustomProperty[] = [];
    RoomPic: string = "None";
    LayeredRoomPic: string = "None";
    bEnterFirstTime: boolean = false;
    bLeaveFirstTime: boolean = false;
    UniqueID: string = "";
    ActionsUseAdvanced: boolean = false;

    cloneForDiff(): {
        Description: string;
        SDesc: string;
        Name: string;
        Exits: any[];
        Actions: any[];
        CustomProperties: any[];
        RoomPic: string;
        LayeredRoomPic: string;
        bEnterFirstTime: boolean;
        bLeaveFirstTime: boolean;
    } {
        return {
            Description: this.Description,
            SDesc: this.SDesc,
            Name: this.Name,
            Exits: (window as any).ArrayCloneForDiff?.(this.Exits) || this.Exits.slice(),
            Actions: (window as any).ArrayCloneForDiff?.(this.Actions) || this.Actions.slice(),
            CustomProperties: (window as any).ArrayCloneForDiff?.(this.CustomProperties) || this.CustomProperties.slice(),
            RoomPic: this.RoomPic,
            LayeredRoomPic: this.LayeredRoomPic,
            bEnterFirstTime: this.bEnterFirstTime,
            bLeaveFirstTime: this.bLeaveFirstTime,
        };
    }
}

export function SetupRoomData(RoomData: any[]): Room {
    const TheRoom = new Room();
    TheRoom.SDesc = RoomData[0];
    TheRoom.Description = RoomData[1];
    TheRoom.Name = RoomData[2];
    TheRoom.Group = RoomData[3];
    TheRoom.RoomPic = RoomData[4];
    TheRoom.LayeredRoomPic = RoomData[5];
    TheRoom.bEnterFirstTime = RoomData[6];
    TheRoom.bLeaveFirstTime = RoomData[7];
    TheRoom.UniqueID = RoomData[8];
    for (let i = 0; i < RoomData[9].length; i++) {
        TheRoom.Exits.push(SetupExitData(RoomData[9][i]));
    }
    for (let j = 0; j < RoomData[10].length; j++) {
        TheRoom.CustomProperties.push(SetupCustomPropertyData(RoomData[10][j]));
    }
    for (let k = 0; k < RoomData[11].length; k++) {
        TheRoom.Actions.push(SetupActionData(RoomData[11][k]));
    }
    TheRoom.ActionsUseAdvanced = Boolean(RoomData[12]);
    return TheRoom;
}
